import api from "../../services/api";

const attendanceService = {
  // Attendance
  recordPunch: async (payload) => {
    const response = await api.post("/api/attendance/punch", payload);
    return response.data;
  },

  getDailyAttendance: async (params = {}) => {
    const response = await api.get("/api/attendance/daily", { params });
    return response.data;
  },

  getAttendanceForDate: async (userId, date) => {
    const response = await api.get(`/api/attendance/daily/${userId}/${date}`);
    return response.data;
  },

  recalculateAttendance: async (payload) => {
    const response = await api.post("/api/attendance/recalculate", payload);
    return response.data;
  },

  getAttendanceReport: async (params = {}) => {
    const response = await api.get("/api/attendance/report", { params });
    return response.data;
  },

  lockAttendance: async (id) => {
    const response = await api.post(`/api/attendance/lock/${id}`);
    return response.data;
  },

  unlockAttendance: async (id) => {
    const response = await api.post(`/api/attendance/unlock/${id}`);
    return response.data;
  },

  // Shift
  listShifts: async (params = {}) => {
    const response = await api.get("/api/shift/shift", { params });
    return response.data;
  },

  createShift: async (payload) => {
    const response = await api.post("/api/shift/shift", payload);
    return response.data;
  },

  updateShift: async (id, payload) => {
    const response = await api.put(`/api/shift/shift/${id}`, payload);
    return response.data;
  },

  deleteShift: async (id) => {
    const response = await api.delete(`/api/shift/shift/${id}`);
    return response.data;
  },

  // Schedule
  listSchedules: async (params = {}) => {
    const response = await api.get("/api/shift/schedule", { params });
    return response.data;
  },

  createSchedule: async (payload) => {
    const response = await api.post("/api/shift/schedule", payload);
    return response.data;
  },

  updateSchedule: async (id, payload) => {
    const response = await api.put(`/api/shift/schedule/${id}`, payload);
    return response.data;
  },

  deleteSchedule: async (id) => {
    const response = await api.delete(`/api/shift/schedule/${id}`);
    return response.data;
  },

  assignScheduleToUser: async (payload) => {
    const response = await api.post("/api/shift/schedule/assign", payload);
    return response.data;
  },

  setDefaultSchedule: async (id) => {
    const response = await api.post(`/api/shift/schedule/${id}/set-default`);
    return response.data;
  },

  // Roster
  createRoster: async (payload) => {
    const response = await api.post("/api/roster", payload);
    return response.data;
  },

  getRosterForDate: async (userId, date) => {
    const response = await api.get(`/api/roster/date/${userId}/${date}`);
    return response.data;
  },

  listRosterForUser: async (userId, params) => {
    const response = await api.get(`/api/roster/user/${userId}`, { params });
    return response.data;
  },

  updateRoster: async (id, payload) => {
    const response = await api.put(`/api/roster/${id}`, payload);
    return response.data;
  },

  deleteRoster: async (id) => {
    const response = await api.delete(`/api/roster/${id}`);
    return response.data;
  },

  // Geofence
  listGeofences: async (params = {}) => {
    const response = await api.get("/api/geofence", { params });
    return response.data;
  },

  createGeofence: async (payload) => {
    const response = await api.post("/api/geofence", payload);
    return response.data;
  },

  updateGeofence: async (id, payload) => {
    const response = await api.put(`/api/geofence/${id}`, payload);
    return response.data;
  },

  deleteGeofence: async (id) => {
    const response = await api.delete(`/api/geofence/${id}`);
    return response.data;
  },
};

export default attendanceService;
